import React from 'react';

const Workforce = React.lazy(() => import('./Community'));

export default Workforce;
